import CryptoJS from 'crypto-js';
import axios from 'axios';

export class TcsApiUtils {
  private static appKey: string = process.env.VUE_APP_TCSAPI_APP_KEY;
  private static signKey: string = process.env.VUE_APP_TCSAPI_SIGN_KEY;

  public static async sendSignedRequest(url: string, params: Record<string, any>) {
    try {
      // 1. 获取当前时间戳
      const timestamp = Date.now();

      // 2. 构建参数字符串
      const paramString = this.buildParamString(params);

      // 3. 拼接字符串
      const signString = `${paramString}&ts=${timestamp}&signKey=${this.signKey}`;

      // 4. 生成签名
      const signature = this.generateSignature(signString);
      console.log('[TcsApiUtils] signString:', signString)
      console.log('[TcsApiUtils] signature:', signature)

      // 5. 设置请求头
      const headers = {
        ts: timestamp.toString(),
        tmpSign: signature,
        appKey: this.appKey,
      };

      // 6. 将参数字符串附加到请求体中
      const requestBody = { ...params };

      // 发送请求
      const response = await axios.post(url, requestBody, { headers });

      // console.log('Response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error:', error);
      throw error;
    }
  }

  private static buildParamString(params: Record<string, any>): string {
    // 递归处理对象和数组，返回排序后的 JSON 字符串
    const sortedParams = this.sortParams(params);

    // 将排序后的参数对象转换为 JSON 字符串
    let jsonString: string = JSON.stringify(sortedParams);

    // 去掉 JSON 字符串中的双引号
    jsonString = jsonString
      .replace(/"([^"]+)":/g, '$1:')  // 去掉属性名的双引号
      .replace(/"([^"]+)"/g, '$1');   // 去掉属性值的双引号

    // 构建查询参数字符串
    return jsonString;
  }

  private static sortParams(params: any): any {
    if (Array.isArray(params)) {
      // 处理数组
      return params.map(item => this.sortParams(item));
    } else if (typeof params === 'object' && params !== null) {
      // 处理对象
      const sortedEntries = Object.entries(params)
        .filter(([_, value]) => value !== null && value !== undefined) // 过滤 null 和 undefined
        .sort(([keyA], [keyB]) => keyA.localeCompare(keyB)) // 按键排序
        .map(([key, value]) => [key, this.sortParams(value)]); // 递归处理值

      return Object.fromEntries(sortedEntries);
    } else {
      // 处理基本类型
      return params;
    }
  }

  private static generateSignature(str: string): string {
    const hash = CryptoJS.MD5(str);
    return hash.toString(CryptoJS.enc.Hex).toUpperCase();
  }
}